import {
  getCompoundProductionSteps,
  removeCompoundProductionStep,
  setCompoundProductionStepFilters,
  updateCompoundProductionStep,
} from '@state/reducers/compoundProductionStepReducer'
import { CompoundProductionStepDto } from '@services/dtos'
import { useEffect } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import CompoundProductionStepForm from '../forms/CompoundProductionStepForm'
import { compoundProductionStepColumns } from '@utils/gridColumns'

export default function CompoundProductionStepsTable() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(setCompoundProductionStepFilters({ includeInactive: false }))
    }
  }, [])

  return (
    <BaseConfigTable<CompoundProductionStepDto>
      columns={compoundProductionStepColumns}
      selectRows={(state) => state.compoundProductionStep.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setCompoundProductionStepFilters({ includeInactive: true }))
        return dispatch(getCompoundProductionSteps())
      }}
      deleteThunk={removeCompoundProductionStep}
      toggleThunk={(id, isActive) =>
        updateCompoundProductionStep({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setCompoundProductionStepFilters({ page }))
        dispatch(getCompoundProductionSteps())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <CompoundProductionStepForm
          editingCompoundProductionStep={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="étape de production MRP"
      resourcePrefix="l'"
    />
  )
}
